module.exports = __webpack_public_path__ + "media/images/spectrum-one-2025-6e33ea0d08b557861f2e40cdcd1d48eb.png";